import { useRef } from 'react';

import { Group } from 'three';

import { useAppSelector } from '../../../hooks.ts';
import { useStore } from '../../../pages/workspace/hooks.ts';
import { MeasurementData } from '../../../store/reducers/workspace.reducer.ts';
import { selectLampWireframeMap } from '../../../store/selectors/workspace.selector.ts';
import { MeasurementVisualizationType } from '../../../types/view';
import { Lamp } from './Lamp.tsx';
import { MeasurementColoredModel } from './MeasurementColoredModel.tsx';
import { MeasurementPoints } from './MeasurementPoints';

type MeasurementsProps = {
  data: MeasurementData[];
  /** Hide the whole-model measurement points (the colored model stays) — used when the
   *  measurement-surfaces switch is on "Surface points". */
  hidePoints?: boolean;
};

const Measurements = ({ data, hidePoints = false }: MeasurementsProps) => {
  const groupRef = useRef<Group>(null);
  const { uploadedModels, lamps, showIESModels, showMeasurementPoints } = useStore();
  const measurementVisualizationType = useAppSelector(
    (state) => state.workspace.measurementVisualizationType,
  ) as MeasurementVisualizationType;
  const wireframeMap = useAppSelector(selectLampWireframeMap);

  return (
    <group ref={groupRef}>
      {showMeasurementPoints && !hidePoints && <MeasurementPoints data={data} />}

      <group>
        {uploadedModels.map((model) => (
          <MeasurementColoredModel
            key={model.name}
            model={model}
            measurementData={data}
            visualizationType={measurementVisualizationType}
            onLoad={() => {}}
          />
        ))}
      </group>

      {lamps.map((lamp) => (
        <Lamp
          key={lamp.id}
          id={lamp.id}
          position={lamp.position}
          name={lamp.name}
          isSelected={lamp.isSelected || false}
          showBulb={!showIESModels}
          showIESModel={showIESModels}
          wireframe={wireframeMap.get(lamp.uuid)}
        />
      ))}
    </group>
  );
};

export { Measurements };
